module.exports = __webpack_public_path__ + "jizvy_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/jizvy_2_after.jpg
// module id = 951
// module chunks = 0